export const getRepairshopFilter = state => state.repairshop.filter
